import React, { useState, useEffect, useMemo } from "react"
import {
  Row,
  Col,
  Card,
  Table,
} from "reactstrap"
import Loader from "pages/Separate/Loader"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import NewPagination from "components/Common/Newpagination"
import { customGlobalFilter } from "utils/common-helpers"
import Select from "react-select"

import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { fetchData, FetchNodePostData } from "utils/common-fetchData.js"
import { WorkLoadReportColumn } from "utils/columns/Work Load/workLoadReportcolumn"

function TableContainer({
  columns,
  data,
  fetchWorkLoadData,
  members,
  setMembers,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state
  const [staffData, setStaffData] = useState([])
  const [today, setToday] = useState("")
  const [isLoading, setLoading] = useState(false)

  const toggleLoading = loading => {
    setLoading(loading)
  }

  useEffect(() => {
    setToday(new Date().toISOString().split("T")[0])
  }, [])

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 1200,
    }),
  }

  const fetchDatas = async () => {
    try {
      const response = await fetchData(
        toggleLoading,
        "allActitvityAccess",
        secureLocalStorage?.getItem("auth_token")
      )
      if (response?.success) {
        console.log("allActitvityAccess", response)
        setStaffData(
          response?.data?.users?.map(obj => ({
            value: obj.id,
            label: obj.name,
          })) || []
        )
      } else {
        console.warn("No valid staff data returned from API")
      }
    } catch (error) {
      console.error("Error fetching staff data:", error)
    }
  }

  useEffect(() => {
    fetchDatas()
  }, [])

  const dateFunction = e => {
    const selectedDate = e.target.value
    if (selectedDate > today) {
      Swal.fire({
        icon: "warning",
        text: "Cannot select future date",
      })
    } else {
      setFromDate(selectedDate)
      console.log(`fromDate: ${selectedDate}`)
    }
  }

  const todateFunction = e => {
    const selectedDate = e.target.value
    if (selectedDate > today) {
      Swal.fire({
        icon: "warning",
        text: "Cannot select future date",
      })
    } else {
      setToDate(selectedDate)
      console.log(`toDate: ${selectedDate}`)
    }
  }

  const handleFilter = () => {
    if (members && members.length > 0 && fromDate && toDate) {
      const ids = members.map(member => member.value)
      fetchWorkLoadData(ids, fromDate, toDate)
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please select at least one member and a date range",
      })
    }
  }

  return (
    <Row>
      <Col xl="12">
        <div className="card-body">
          <div className="d-flex justify-content-between mb-2">
            <div className="mb-3 text-purple fs-5 fw-bold">
              Work Load Report
            </div>
          </div>
          <Row className="mb-2">
            <div className="d-flex justify-content-between align-items-center flex-wrap w-100 gap-3 px-3">
              {/* Left Group: Page Size & Member Select */}
              <div className="d-flex align-items-center gap-3 flex-wrap">
                {/* Page Size Dropdown */}
                <div>
                  <select
                    className="form-select"
                    style={{ width: "100px" }}
                    value={pageSize}
                    onChange={e => setPageSize(e.target.value)}
                  >
                    {[10, 25, 50, 100].map(size => (
                      <option key={size} value={size}>
                        Show {size}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Right Group: Filter Button & Date Picker */}
              <div className="d-flex align-items-center gap-2 flex-nowrap">
                {/* Select Member */}
                <div style={{ minWidth: "500px", maxWidth: "500px" }}>
                  <Select
                    placeholder="Select Member"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={staffData}
                    isMulti
                    value={members}
                    onChange={selectedOption => setMembers(selectedOption)}
                    id="member-select"
                  />
                </div>
                {/* Date Picker */}
                <input
                  type="date"
                  id="startDate"
                  className="form-control"
                  value={fromDate}
                  onChange={dateFunction}
                />
                <input
                  type="date"
                  id="endDate"
                  className="form-control"
                  value={toDate}
                  onChange={todateFunction}
                />

                {/* Filter Button */}
                <a
                  className="btn btn-sm me-1 bg-purple text-white"
                  style={{ borderRadius: "5px" }}
                  onClick={handleFilter}
                >
                  <i className="bi bi-funnel-fill fs-5"></i>
                </a>
              </div>
            </div>
          </Row>

          <div className="position-relative table-responsive">
            <Table className="table table-bordered mt-4" {...getTableProps()}>
              <thead className="fixed_view_payment_table">
                {headerGroups.map((headerGroup, i) => (
                  <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th
                        key={index}
                        className={`t-col-${index + 1} ${column.className}`}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        <div className="d-flex align-items-center">
                          <span className="flex-grow-1 text-center header-text">
                            {column.render("Header")}
                          </span>
                          {column.isShortIcon && (
                            <span
                              onClick={() =>
                                column.getSortByToggleProps().onClick()
                              }
                              className="d-flex align-items-center ms-2"
                            >
                              <i
                                title="Ascending"
                                className={`bi bi-arrow-up info-icon ${
                                  column.isSorted && !column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                }`}
                              ></i>
                              <i
                                title="Descending"
                                className={`bi bi-arrow-down info-icon ${
                                  column.isSorted && column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                }`}
                              ></i>
                            </span>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody className="fix-introducer-header" {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row)
                  return (
                    <tr className="row-hover" {...row.getRowProps()} key={i}>
                      {row.cells.map((cell, index) => (
                        <td key={index} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </div>

          <Row className="justify-content-md-end justify-content-center align-items-center">
            <NewPagination
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
              pageSize={pageSize}
              page={page}
              data={data}
              nextPage={nextPage}
            />
          </Row>
        </div>
      </Col>
    </Row>
  )
}

const WorkLoadReport = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [errorMsg, setErrorMsg] = useState("")
  const [members, setMembers] = useState([])
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")

  const token = secureLocalStorage.getItem('auth_token')
  const toggleLoading = loading => {
    setLoading(loading)
  }

  const fetchWorkLoadData = async (ids, start_date, end_date) => {
    try {
      toggleLoading(true)
      const formData = {
        id: ids,
        start_date,
        end_date,
      }
      const response = await FetchNodePostData(
        setLoading,
        "/workReport",
        token,
        formData
      )

      if (response.data.status === true) {
        setData(response.data.data || [])
        setErrorMsg("")
      } else {
        setErrorMsg("Failed to fetch work load data.")
        setData([])
      }
    } catch (error) {
      console.error("Error fetching work load data:", error)
      setErrorMsg("An error occurred while fetching the data.")
      setData([])
    } finally {
      toggleLoading(false)
    }
  }

  const column1 = useMemo(() => WorkLoadReportColumn(), [])

  return (
    <div>
      {isLoading && <Loader />}
      {errorMsg && (
        <div className="text-center text-danger my-3 fw-bold">{errorMsg}</div>
      )}
      {!isLoading && (
        <div className="position-relative">
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table">
                  <TableContainer
                    columns={column1}
                    data={data}
                    fetchWorkLoadData={fetchWorkLoadData}
                    members={members}
                    setMembers={setMembers}
                    fromDate={fromDate}
                    setFromDate={setFromDate}
                    toDate={toDate}
                    setToDate={setToDate}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}

export default WorkLoadReport
